export enum ReasonEnum {
  marital_status_reason_value = "change_in_marital_status",
  financial_circumstances_reason_value = "change_in_financial_circumstances",
  demise_current_owner_reason_value = "demise_of_current_owner",
  loss_of_citizenship_reason_value = "loss_of_citizenship",
  owner_moving_out_reason_value = "owner_moving_out",
  health_reasons_reason_value = "health_reasons"
}
